export default __webpack_public_path__ + "static/logo_var_orange_game_jam-403be012f2396dfdb7927e6f0d5564a5.png";